import { css, keyframes } from '@emotion/core'
import { ShowAni, mqPC } from '@styles/base.style'
import styled, { Theme, ThemeProps } from '@themes/theme'
import { CheckBoxMonoToneStyle } from '@styles/button.style'

export const LoginPopupWrap = styled.div`
  position: absolute;
  top: 0;
  left:0;
  width: 100%;
  height: 100%;
  background: ${props => props.theme.color.themeTxt};
`
export const SplashAni = keyframes`
  0%,100% {
    z-index: -1;
    opacity:0;
    display:none;
  }
  30%,70% {
    z-index: 1;
    opacity:1;
    display:block;
  }
`
export const LoginBgWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
`
export const LoginBgStyle = css`
  position: absolute;
  top: 0;
  left: 50%;
  width: auto;
  min-width: 100%;
  height: auto;
  min-height: 150vw; /* 갤럭시 키패드 올라왔을때 이미지가 찌그러지는 현상 해결 */
  max-height: 100vh;
  transform: translate(-50%, 0);
  /* PC */
  ${mqPC[6]}{
    width: 800px;
    height: 1420px;
    min-height: 1420px;
    max-height: 1420px;
  }
`
export const SplashWrap = styled.div`
  position: absolute;
  top: 0%;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  animation: ${SplashAni} 3s forwards !important;
`
export const TxtWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  text-align: center;
  transform: translate(-50%, -110%);
`
export const Txt = styled.p`
  width: 100%;
  line-height: 2.2rem;
  animation: ${ShowAni} 1s ease-in-out !important;
`
export const ImgWrap = styled.div`
  position: absolute;
  bottom: 12%;
  width: 100%;
  text-align: center;
  opacity: 0;
  animation: ${ShowAni} 1s ease-in-out forwards !important;
  animation-delay: 0.15s !important;
`


// logo animaiton
// const LogoAni = (props: ThemeProps) => keyframes`
// 0% {-webkit-filter: drop-shadow( -.75px 0px 6px #b8e8ff );
//                 filter: drop-shadow( -.75px 0px 6px #b8e8ff ); stroke:#b8e8ff;}
//    30% {-webkit-filter: drop-shadow( -.75px 0px 6px #57a5de );
//                 filter: drop-shadow( -.75px 0px 6px #57a5de ); stroke:#57a5de;}
//    50% {-webkit-filter: drop-shadow( -.75px 0px 6px  #31a7de  );
//                 filter: drop-shadow( -.75px 0px 6px  #31a7de  ); stroke: #31a7de ;}
//    70% {-webkit-filter: drop-shadow( -.75px 0px 6px #57a5de );
//                 filter: drop-shadow( -.75px 0px 6px #57a5de ); stroke:#57a5de;}
//   100% {-webkit-filter: drop-shadow( -.75px 0px 6px #b8e8ff );
//                 filter: drop-shadow( -.75px 0px 6px #b8e8ff ); stroke:#b8e8ff;}
// `
export const LogoStyle = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 74px;
  svg {
    /* svg의 너비/높이를 지정하지 않으면 edge에서 보여지지않음 */
    width: auto;
    height: 57px;
    opacity: .5;
    path {
      fill: ${props => props.theme.color.disableTxt};
    }
  }

`
// 웹
export const LoginWrap = styled.div`
  .version {
    position: absolute;
    top:18px;
    left: 18px;
    font-size: ${props => props.theme.font.small};
    color: ${props => props.theme.color.modalSubTxt};
  }
`
export const FormStyle = (theme: Theme) => css`
  position: relative;
  top: 34px;
  left: 0;
  width: 100%;
  height: 345px;
  padding: 0 37px !important;
  text-align: center;
  .id,
  .pw {
    .ant-form-item-control-wrapper {
      height: 33px;
    }
  }
  .id {
    &:hover, &:focus, &:active {
      & ~ .ant-form-item-btn.id {
        animation: ${ShowAni} 1s ease forwards;
      }
    }
  }
  .pw {
    &:hover, &:focus, &:active {
      & ~ .ant-form-item-btn.password {
        animation: ${ShowAni} 1s ease forwards;
      }
    }
  }
  .ant-form-item-control {
    position: relative;
    line-height: 3rem;
  }
  .ant-form-item {
    position: relative;
    width: 100%;
    margin-bottom: 0;
    transition: all 0.3s;
    &.id, &.pw {
      position: relative;
      height: 43px;
      .ant-form-explain {
        padding-left: 32px;
      }
      &::before {
        content:'';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        background: ${theme.color.modalBg};
        opacity: .5;
        border-radius: 50px;
      }
      .ant-form-item-control {
        display: flex;
        padding: 0;
        .ant-form-item-children {
          width: 100%;
          padding-left: 34px;
          svg {
            position: absolute;
            top: 50%;
            left: 17px;
            width: auto;
            height: 12px;
            transform: translateY(-50%);
          }
        }
      }
      &:hover, &:active, &:focus {
        svg path {
          fill: ${theme.color.modalBlue};
        }
      }
    }
    &.id {
      margin-bottom: 14px;
    }
    &.id-save {
      margin: 16px 0;
      padding-left: 15px;
      border-bottom: none;
      .ant-checkbox {
        position: relative;
        transform: translate(0,4%);
        width: 16px;
        height: 16px;
        input {
          width: inherit;
          height: inherit;
        }
        .ant-checkbox-inner {
          width: inherit;
          height: inherit;
          background: none;
          border-radius: 50%;
          border: 2px solid ${theme.color.modalgray};
          &::before {
            content: '';
            position: absolute;
            top: 50%;
            width: 6px;
            height: 9px;
            left: 28%;
            border: 2px solid ${theme.color.modalgray};
            border-top: 0;
            border-left: 0;
            transform: rotate(45deg) scale(.85) translate(-80%, -50%);
          }
        }
        & + span {
          color: ${theme.color.modalSubTxt};
        }
      }
      .ant-checkbox.ant-checkbox-checked .ant-checkbox-inner {
        background: ${theme.color.modalBlue} !important;
        border-color: ${theme.color.modalBlue} !important;
        &::after {
          width: 6px;
          height: 9px;
          left: 28%;
          border: 2px solid ${theme.color.themeTxt};
          border-top: 0;
          border-left: 0;
          transform: rotate(45deg) scale(.85) translate(-80%, -50%);
        }
      }
      .ant-checkbox-checked::after {
        border-radius: 50%;
      }
    }
    .row {
      position: relative;
      &::before {
        content:'';
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 38%;
        height: 8px;
        border-left: 1px solid ${theme.color.disableTxt};
        border-right: 1px solid ${theme.color.disableTxt};
        transform: translate(-43%,-50%);
      }
    }
    &:hover,
    &:focus,
    &:active {
      .ant-form-item-btn {
        animation: ${ShowAni} 1s ease forwards;
      }
      .ant-form-item-children svg {
        fill: ${theme.color.modalBlue};
      }
    }
  }
  .ant-input {
    height: 43px;
    padding: 0;
    border: none;
    outline: none;
    color: ${theme.color.modalSubTxt};
    font-size: ${theme.font.medium};
    background: ${theme.color.TP};
    border-radius: 0;
    &::placeholder {
      color: ${theme.color.modalDarkBg} !important;
    }
    &:hover, &:active, &:focus {
      border: none !important;
    }
  }
  .has-error .ant-input-affix-wrapper .ant-input,
  .has-error .ant-input-affix-wrapper .ant-input:hover {
    background: ${theme.color.TP};
  }
  .live-score-badge {
    width: 24px;
    height: auto;
    margin-left: 4px;
    transform: translateY(-2px);
    float: right;
  }
`
const SubBtnStyle = css`
  opacity: 0;
  position: absolute;
  top: 14px;
  width: 16px;
  height: 16px;
  border: none;
  border-radius: 50%;
  transition: all 0.3s;
  /* 비밀번호란 */
  &.password {
    top: 70px;
  }
`
export const RightBtnStyle = (theme: Theme) => css`
  ${SubBtnStyle};
  right: 54px;
`
export const LeftBtnStyle = (theme: Theme) => css`
  ${SubBtnStyle};
  right: 85px;
`
export const LeftIconStyle = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
export const LoginTxt = styled.span`
  position: relative;
  padding: 5px 0;
  color: ${props => props.theme.color.modalgray};
  &#signUp {
    color: ${props => props.theme.color.modalBlue};
  }
`
// 로그인 아이콘 공통 스타일
const LoginImgStyle = css`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 19px;
  height: auto;
  transform: translate(-50%, -50%);
`
const LoginBtnStyle = css`
  width: 100%;
  height: 43px;
`
export const LoginButtonStyle = css`
  ${LoginBtnStyle};
  margin-bottom: 20px;
`
export const SocialLogin = styled.div`
  .social-login-txt {
    position:relative;
    width: 100%;
    margin: 32px 0 20px;
    line-height: 1.5rem;
    color: ${props => props.theme.color.modalgray};
    font-size:  ${props => props.theme.font.small};
    text-align: center;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left:0;
      display: block;
      width: 34%;
      transform: translate(0,-50%);
      border-bottom: 1px solid ${props => props.theme.color.modalSubBg};
    }
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right:0;
      display: block;
      width: 34%;
      transform: translate(0,-50%);
      border-bottom: 1px solid ${props => props.theme.color.modalSubBg};
    }
    svg {
      width: 12px;
      height: auto;
      margin-right: 1px;
      transform: translateY(2px);
    }
  }
  .social-btn-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    margin: 0 auto;
  }
`

export const SocialLoginRealBtnWrap = styled.div`
  display:none ;
`

export const SocialBtnStyle = (theme: Theme) => css`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  line-height: 1.2rem;
  text-align: center;
  margin: 0 17px 10px 17px;
  span {
    display: none;
  }
  img {
    image-rendering: -webkit-optimize-contrast;
  }
  &.naver {
    background: #00BF18;
    .social-btn-txt {
      color: ${theme.color.themeTxt};
    }
  }
  &.kakao {
    background: #FEE500;
  }
  &.apple {
    background: #000;
  }
  &.google {
    border-radius: 50px !important;
    box-shadow: none !important;
    opacity: 1 !important;
    div {
      margin: 0 10px;
      background: none !important;
      transform: translate(1px, 1px);
    }
    /* web */
    svg {
      width: 19px;
      path:first-of-type {
        fill: #ea4335 !important;
      }
      path:nth-of-type(2) {
        fill: #4285f4 !important;
      }
      path:nth-of-type(3) {
        fill: #fbbc05 !important;
      }
      path:nth-of-type(4) {
        fill: #34a853 !important;
      }
      path:last-of-type {
        fill: none !important;
      }
    }
  }
  /* app */
  &.app {
    svg {
      ${LoginImgStyle};
      path:first-of-type {
        fill: #4285f4 !important;
      }
      path:nth-of-type(2) {
        fill: #34a853 !important;
      }
      path:nth-of-type(3) {
        fill: #fbbc05 !important;
      }
      path:nth-of-type(4) {
        fill: #ea4335 !important;
      }
      path:last-of-type {
        fill: none !important;
      }
    }
  }
`
export const MonoRadioBoxStyle = (props: ThemeProps) => css`
  .ant-radio-inner {
    background: none;
    border: 2px solid ${props.theme.color.modalDarkBg};
    &::after {
      background: ${props.theme.color.accordion2};
      border: none;
      top: 2px;
      left: 2px;
    }
  }
  .ant-radio {
    & + span {
      font-size: ${props.theme.font.medium};
      font-weight: ${props.theme.fontW.bold};
      color: ${props.theme.color.modalTxt};
    }
    & + * {
      padding: 0;
    }
  }
  &.ant-radio-wrapper-checked {
    .ant-radio-inner {
      border-color: ${props.theme.color.accordion2};
    }
    border-color:${props.theme.color.accordion2};
    &::after {
      background: ${props.theme.color.accordion2};
      border: none;
    }
    .ant-radio-checked {
      &::after {
        display: none;
      }
    }
  }
  .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: none;
  }
  &.ant-radio-wrapper-disabled {
    .ant-radio-disabled {
      & + span {
        color: ${props.theme.color.gray};
        font-weight: ${props.theme.fontW.regular};
      }
    }
    .ant-radio-inner {
      border-color: ${props.theme.color.modalBg} !important;
      border: 2px solid ${props.theme.color.modalBg};
      background: ${props.theme.color.modalBg};
    }
  }
`
export const AccountTransferInfoWrap = styled.div`
  background: ${props => props.theme.color.themeTxt};
  padding: 50px 24px 0 30px;
  overflow-x: hidden;
   .point-color {
    color: ${props => props.theme.color.modalred};
   }
   .kakao-notice-title {
     color: ${props => props.theme.color.modalTxt};
   }
  .notice-summary {
    margin-top: 10px;
    &--text {
      font-size: ${props => props.theme.font.medium};
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.modalSubTxt};
      strong {
        color: ${props => props.theme.color.modalTxt};
        font-weight: ${props => props.theme.fontW.bold};
      }
      &.detail {
        margin-top: 16px;
        color: ${props => props.theme.color.modalSubTxt};
        font-weight: ${props => props.theme.fontW.medium};
        &:last-child {
          margin-bottom: 45px;
        }
      }
    }
  }
  .article {
    .article-tit {
      font-size: ${props => props.theme.font.title};
      font-weight: ${props => props.theme.fontW.bold};
      color: ${props => props.theme.color.modalTxt};
      margin-bottom: 4px;
    }
    .article-txt {
      font-size: ${props => props.theme.font.medium};
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.modalSubTxt};
      margin-bottom: 45px;
    }
  }
  .account-transfer-txt {
    font-size: ${props => props.theme.font.medium};
    font-weight: ${props => props.theme.fontW.medium};
    color: ${props => props.theme.color.modalgray};
    margin-bottom: 14px;
  }
  .ant-radio-group {
    margin-bottom: 28px;
    width: 100%;
  }
  .account-transfer-list {
    width: calc(100% - 6px);
    border-radius: 8px;
    margin-bottom: 6px;
    border: 1px solid ${props => props.theme.color.modalSubBg};
    // 이관 가능 계정 목록
    &.ant-radio-wrapper {
      ${MonoRadioBoxStyle};
      line-height: 48px;
      height: 48px;
      .ant-radio {
        padding: 0 10px 0 9px;
        & + span {
          .account-name, .account-address, .availability {
            font-size: ${props => props.theme.font.medium};
            font-weight: ${props => props.theme.fontW.bold};
            color: ${props => props.theme.color.modalTxt};
          }
          .account-address {
            margin: 0 auto 0 19px;
            font-weight: ${props => props.theme.fontW.medium};
          }
          .availability {
            width: 52px;
            display: inline-flex;
            flex-wrap: wrap;
            justify-content: center;
          }
        }
      }
      > span:not(.ant-radio) {
        //width: calc(100% - 54px);
        width: calc(100% - 54px + 13px);
        display: inline-flex;
        justify-content: space-between;
      }
    }
    &.ant-radio-wrapper-disabled {
      .ant-radio-disabled {
        & + span {
          .account-name, .account-address, .availability, .reason {
            font-size: ${props => props.theme.font.medium};
            font-weight: ${props => props.theme.fontW.medium};
            color: ${props => props.theme.color.gray};
          }
          .availability {
            line-height: 36px;
            .reason {
              width: 100%;
              display: block;
              line-height: 12px;
              transform: translate(0, -10px);
            }
          }
          .account-address {
            font-weight: ${props => props.theme.fontW.regular};
          }
        } 
      }
    } // 이관 가능 계정 목록
    &.impossible {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 55px;
      text-align: center;
      .point-color {
        transform: translateY(2px);
      }
    }
  }
  .bottom-notice {
    position: relative;
    padding: 30px 0 60px 3px;
    &.no-bg { // 이관 가능한 계정이 없을 경우 안내 텍스트 스타일
      padding-top: 10px;
      ::before {
        display: none;
      }
      .point-color { // 이관 가능한 계정이 없을 경우 안내 텍스트 스타일
        display: block;
        text-align: center;
        margin-bottom: 30px;
      }
    }
    ::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% + 30px + 24px);
      height: 100%;
      background: #DDDDDDB3;
    }
    .notice-title {
      position: relative;
      margin-bottom: 14px;
      .light-bulb-icon {
        width: auto;
        height: 20px;
        margin: 0 4px -2px 0;
      }
      font-size: ${props => props.theme.font.title};
      font-weight: ${props => props.theme.fontW.bold};
      color: ${props => props.theme.color.modalTxt};
      &.check-list {
        width: 111px;
        height: 25px;
        line-height: 27px;
        text-align: center;
        color: ${props => props.theme.color.themeTxt};
        background: ${props => props.theme.color.accordion2};
      }
    }
    &-list {
      position: relative;
      margin-bottom: 18px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .bullet {
        display: block;
       min-width: 3px;
       width: 3px;
       height: 3px;
       border-radius: 50%;
       background: ${props => props.theme.color.modalTxt};
       margin: 7px 8px 0 0;
     }
     font-size: ${props => props.theme.font.medium};
     font-weight: ${props => props.theme.fontW.medium};
     color: ${props => props.theme.color.modalSubTxt};
    }
    // 이관 시 필독 체크사항
    .transfer-contents-list {
      position: relative;
      z-index: 1;
      margin-bottom: 30px;
      &--item {
        .agree-check-box {
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
          ${CheckBoxMonoToneStyle};
          > span:not(.ant-checkbox) {
            padding: 14px 17px 14px 0;
            margin-right: 13px;
            font-size: ${props => props.theme.font.medium};
            font-weight: ${props => props.theme.fontW.medium};
            color: ${props => props.theme.color.modalSubTxt};
            border-bottom: 1px solid ${props => props.theme.color.modalSubBg};
            .bold {
              color: ${props => props.theme.color.modalTxt};
              font-weight: ${props => props.theme.fontW.bold};
            }
          }
          &.first-list {
            > span:not(.ant-checkbox) {
              padding-top: 0;
            }
          }
        }
      }
    }
 }
 .impossible-Instruction {
   margin-bottom: 25px;
   font-size: ${props => props.theme.font.medium};
   font-weight: ${props => props.theme.fontW.medium};
   color: ${props => props.theme.color.modalSubTxt};
 }
`

export const CreateAccountBtn = (theme: Theme) => css`
  display: block;
  margin: 0 auto 24px;
  transform: translateX(-3px);
  width: 227px;
  height: 56px;
  background: ${theme.color.modalyellow};
  border-radius: 50px;
  .btn-txt {
    display: flex;
    margin: 0 auto;
    width: auto;
    height: 23px;
  }
  &.application-btn {
    background: ${theme.color.modalSubBg};
    transition: .3s;
    &.active {
      background: ${theme.color.mainBg};
    }
  }
`
export const LaterBtn = (theme: Theme) => css`
  display: block;
  margin: 0 auto 30px;
  transform: translateX(-3px);
  font-size: ${theme.font.medium};
  font-weight: ${theme.fontW.medium};
  color: ${theme.color.modalgray};
  position: relative;
  ::before {
    position: absolute;
    display: block;
    content: '';
    bottom: -1px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 1px;
    background: ${theme.color.modalgray};
  }
`
